<template>
  <el-card class="box-card" v-loading="isLoading">
    <div slot="header" class="clearfix">
      <el-row type="flex" class="row-bg">
        <el-col :span="23">
          <span class="table-title">Fórmula - {{ id }}</span>
        </el-col>
      </el-row>

      <div class="row">
        <div class="col-5">
          <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="Nome" prop="field">
              <el-input :disabled="isDisable" v-model="form.nome" size="medium" autosize></el-input>
            </el-form-item>
            <el-form-item disable label="Macro" prop="field">
              <el-input :disabled="isDisable" v-model="form.macro" size="medium"></el-input>
            </el-form-item>
            <div class="bottom clearfix">
              <el-button type="danger" style="float: right;margin: 20px" @click="excluir()" :loading="isProcessing">
                Excluir
              </el-button>
              <el-button type="primary" style="float: right;margin: 20px" @click="listar()">Lista</el-button>
              <el-button type="warning" style="float: right;margin: 20px" @click="isDisable=false" v-show="isDisable">
                Editar
              </el-button>
              <el-button type="success" style="float: right;margin: 20px" @click="salvar()" v-show="!isDisable">Salvar
              </el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>

  import {mapState} from 'vuex'

  export default {
    name: "formula-show",
    data() {
      return {
        isDisable: true,
        isLoading: true,
        isProcessing: false,
        form: {id: '', nome: '', macro: ''}
      }
    },
    computed: {
      id() {
        return this.$route.params.id
      }
    },
    methods: {
      async salvar() {
        try {

          await axios.put(`${process.env.API_PATH}/formula/${this.$route.params.id}`, this.form)
          this.$message({
            type: 'success',
            message: 'Atualizado  com sucesso!'
          });
        } catch (error) {
          this.$message({
            type: 'danger',
            message: 'Erro ao excluir contate o admisnistrador do sistema!'
          });
        }

      },
      async excluir() {
        this.$confirm('Deseja excluir este registro?', 'Cuidado', {
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não Excluir',
          type: 'warning'
        }).then(async () => {
          this.isProcessing = true
          try {
            await axios.delete(`${process.env.API_PATH}/formula/${this.id}`)
            this.$message({
              type: 'success',
              message: 'Excluido com sucesso!'
            });
            this.listar()
          } catch (error) {
            this.$message({
              type: 'danger',
              message: 'Erro ao excluir contate o admisnistrador do sistema!'
            });
          }
          this.isProcessing = false
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Ação Cancelada'
          });
        });
      },
      listar() {
        this.$router.push({name: 'formula.index'})
      },
      async load() {
        try {
          this.form = (await axios.get(`${process.env.API_PATH}/formula/${this.$route.params.id}`)).data
        } catch (error) {
          console.log(error)
          this.$message({
            type: 'danger',
            message: 'Erro. Contate o admisnistrador do sistema!'
          });
        }
        this.isLoading = false
      }
    },
    async mounted() {
      await this.load()
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/Formula/Show.vue